<div class="layout-container"
     [class.layout-collapsed]="isLayoutCollapsed"
     [class.sidepane-visible]="isSidePaneVisible">
  <app-header></app-header>
  <app-sidebar (collapsedChange)="onSidebarCollapsed($event)"></app-sidebar>
  <div class="layout-content-wrapper">
    <div class="layout-content">
      <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
  </div>
  <app-sidepane></app-sidepane>
</div>
